import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, CircularProgress, Tab, Tabs } from '@mui/material';

import type { Tag } from '~/services/TagsService';

interface TagFormHeaderProps {
  tab: string;
  tag: Tag;
  isSaving: boolean;
  onBack: () => void;
  onSave: () => void;
  onTabChange: (tab: string) => void;
}

export default function TagFormHeader({ tab, tag, isSaving = false, onBack, onSave, onTabChange }: TagFormHeaderProps) {
  const title = tag?.id ? `Edit Tag: ${tag.name}` : 'Create Tag';
  return (
    <>
      <Box mb={3} display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" gap={2} alignItems="center">
          <Button variant="text" startIcon={<ArrowBackIcon />} onClick={onBack}>
            Back to List
          </Button>
          <Box component="h2" m={0}>
            {title}
          </Box>
        </Box>
        {!tag && (
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              startIcon={isSaving ? <CircularProgress size={20} /> : <SaveIcon />}
              onClick={onSave}
              disabled={isSaving}
            >
              Save
            </Button>
          </Box>
        )}
      </Box>
      <Box borderBottom={1} borderColor="divider" component="div">
        <Tabs value={tab} onChange={(_, tab) => onTabChange(tab)}>
          <Tab value="assignments" label="Assignments" />
          <Tab value="schedules" label="Schedules" />
        </Tabs>
      </Box>
    </>
  );
}
